<div class="containerr" *ngIf="libros$ | async as libros; else loading">
    <ng-container *ngFor="let curso of libros">
        <mat-card>
            <mat-card-title [routerLink]="['/entrada',curso.id]">
                <span>{{curso.titulo}}</span>  
            </mat-card-title>
            <a mat-raised-button (click)="ira(curso.url)" style="background-color: green;">Descargar</a>
        </mat-card>
    </ng-container>
</div>

<ng-template #loading>
    
    <div id="load">
    
         <div class="container-spinner">
            <mat-spinner color="accent">Cargando...</mat-spinner>
         </div>
         <!-- <img src="../../../assets/spinner.gif" alt="" id="imagenSpin"> -->
     </div>
</ng-template>